import { browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './app/reducers/rootReducer';
import config from './config';
import { LANGUAGES } from './app/constants';

/*
	Store: Redux app has a global store for components to share data
	Params:
		1. combined reducer (root reducer)
		2. optional default/initial state
		3. optional middleware (can be compose with dev tool extensions, etc)
 */
var default_lang = null;
LANGUAGES.forEach(function (language) {
	if (language.name === localStorage.getItem('lang')) {
		default_lang = language;
	}
});

const defaultState = {
	data: {
		userInfo: {},
		loginLog: [],
		sensitiveOps: [],
		language: default_lang||LANGUAGES[0],
		gameOtpConfigs: null
	},
	verification: {
		current_action: null,
		get_status: 0,
		verify_status: 0,
		loading: false,
		sent_count: 0,
	},
	password: {
		current_action: null,
		status: 0
	},
	mobile: {
		current_action: null,
		status: 0,
		mobile_no: ''
	},
	email: {
		current_action: null,
		status: 0,
		email: ''
	},
	realinfo: {
		current_action: null,
		status: 0
	},
	emailVerification: {
		current_action: null,
		status: 0
	},
	unlock: {
		current_action: null,
		status: 0
	},
	errorSecurity: {
		title: '',
		message: '',
	},
	doneSecurity: {
		title: '',
		message: '',
	},
	facebook: {},
};


const composeEnhancer = config.DEBUG &&
typeof window === 'object' &&
window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
: compose;

const enhancers = composeEnhancer(applyMiddleware(thunk));

// var enhancers = applyMiddleware(thunk);
// if (config.DEBUG) {
// 	enhancers = compose(applyMiddleware(thunk), window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
// }
const store = createStore(rootReducer, defaultState, enhancers);
/*
	History: keeps track of browsing history
 */
export const history = syncHistoryWithStore(browserHistory, store);

export default store;


// WEBPACK FOOTER //
// ./store.js